export default "__VITE_PUBLIC_ASSET__f61edcca__"